module.exports = __webpack_public_path__ + "static/img/thumb_8.8f3409c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_8.png
// module id = qUV/
// module chunks = 0